import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6adc924f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "navbar"
};
const _hoisted_2 = {
  class: "right-menu"
};
const _hoisted_3 = {
  class: "avatar-wrapper"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-s-tools"
}, null, -1));
import 'vue';
import { useStore } from 'vuex';
import { ElMessageBox } from 'element-plus';
import Hamburger from '@/components/hamburger';
import Breadcrumb from '@/components/Breadcrumb';
import ThemePicker from '@/components/ThemePicker';
import Screenfull from '@/components/Screenfull';
import HeaderSearch from '@/components/HeaderSearch';
import Guide from '@/components/Guide';
import { useRouter } from 'vue-router';
export default {
  __name: 'Navbar',
  setup(__props) {
    const store = useStore();
    const logout = () => {
      ElMessageBox.confirm('确认退出登录吗', '温馨提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确认'
      }).then(() => {
        store.dispatch('user/logout');
      });
    };
    const router = useRouter();
    const handleUpdatePwd = () => {
      router.push('/password');
    };
    const handleToBindWechat = () => {
      router.push('/hisBind');
    };
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Hamburger), {
        class: "hamburger-container"
      }), _createVNode(_unref(Breadcrumb), {
        id: "guide-breadcrumb",
        class: "breadcrumb-container"
      }), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(Guide), {
        class: "right-menu-item hover-effect"
      }), _createVNode(_unref(HeaderSearch), {
        class: "right-menu-item hover-effect"
      }), _createVNode(_unref(Screenfull), {
        class: "right-menu-item hover-effect"
      }), _createVNode(_unref(ThemePicker), {
        class: "right-menu-item hover-effect"
      }), _createVNode(_component_el_dropdown, {
        class: "avatar-container",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
          class: "user-dropdown"
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: "/"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
              default: _withCtx(() => [_createTextVNode(" 首页 ")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: handleUpdatePwd
          }, {
            default: _withCtx(() => [_createTextVNode(" 修改密码 ")]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: handleToBindWechat
          }, {
            default: _withCtx(() => [_createTextVNode(" 绑定微信 ")]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            divided: "",
            onClick: logout
          }, {
            default: _withCtx(() => [_createTextVNode(" 退出登录 ")]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_avatar, {
          shape: "square",
          size: 40,
          src: "/yiyaLogo.png",
          style: {
            "background-color": "transparent"
          }
        }), _hoisted_4])]),
        _: 1
      })])]);
    };
  }
};